import { DomSanitizer } from '@angular/platform-browser';
import { PipeTransform, Pipe } from '@angular/core';

/**
 * Security Note:
 * Do not use this pipe on any unfiltered user input or remote data.
 * Usage: <div [innerHTML]="mySafeHtml | safeHtml"></div>
 */
@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
